import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareCommentingEnabledMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  commentingEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareCommentingEnabledMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, commentingEnabled: boolean } | { __typename?: 'CollectionShare', id: string, commentingEnabled: boolean } | null } | null };


export const UpdateShareCommentingEnabled = /*#__PURE__*/ gql`
    mutation UpdateShareCommentingEnabled($shareId: ID!, $commentingEnabled: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {commentingEnabled: $commentingEnabled}}
  ) {
    share {
      id
      commentingEnabled
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareCommentingEnabledMutation, UpdateShareCommentingEnabledMutationVariables>;

          

          export const useUpdateShareCommentingEnabledMutation = (options?:MutationHookOptions<UpdateShareCommentingEnabledMutation, UpdateShareCommentingEnabledMutationVariables>) => useMutation(UpdateShareCommentingEnabled, options);
          

          export type UpdateShareCommentingEnabledMutationOptions = MutationHookOptions<UpdateShareCommentingEnabledMutation, UpdateShareCommentingEnabledMutationVariables>;

          

          export type UpdateShareCommentingEnabledMutationResult = ReturnType<typeof useUpdateShareCommentingEnabledMutation>[1];

          
